import { i18n } from '@src/i18n-setup';
import { isNil } from 'lodash';
import { FieldsEnum, getFieldCurrency } from '@utils/fields/common';
import { getOngoingFees } from '@enums/ongoing-fee-enum';
/**
 * Builds the ongoing fees label based on the offer information.
 *
 * @param {Object} The offer
 * @return {String} The translated label.
 */
export default function getOfferOngoingFeesData(offer) {
  if (isNil(offer) || isNil(offer.ongoing_fees_value)) {
    return FieldsEnum.EMPTY;
  }

  const label = i18n.t('dashboard.offer.ongoing_fees_period.per_annum');
  const value = getOngoingFees(offer);

  if (offer.ongoing_fees_waived) {
    return {
      oldValue: getFieldCurrency(value),
      value: `${getFieldCurrency(0)} ${label}`,
    };
  }

  return {
    value: `${getFieldCurrency(value)} ${label}`,
  };
}
